import Slider from '@mui/material/Slider'
import Switch from '@mui/material/Switch'
import { styled } from '@mui/material/styles'
import { grey } from '@mui/material/colors'
import MobileStepper from '@mui/material/MobileStepper'
import Fab from '@mui/material/Fab'
import usflag from './svg/us.svg'
import jpflag from './svg/jp.svg'
import AppBar  from '@mui/material/AppBar';
import { isMobile } from './utils/deviceUtils';

export const MainAppBar = styled(AppBar)(({ theme }) => ({
  top: 0,
  position: 'absolute',
  backgroundColor: 'rgba(0, 0, 0, 0.85)',
  backdropFilter: 'blur(5px)',
  webkitBackdropFilter: 'blur(5px)',
  '& .MuiToolbar-root': {
    '& .MuiIconButton-root': {
      '&:focus, &:hover, &.Mui-active': {
        boxShadow:
          '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
        '@media (hover: none)': {},
      },
    },
    '& .MuiTypography-root': {
      backgroundColor: 'unset',
      color: theme.palette.text.primary,
      '&:before': {
        display: 'none',
      },
      '& *': {
        background: 'transparent',
      },
    },
    '& .MuiDivider-root': {
      opacity: 0.35,
      backgroundColor: '#bfbfbf',
    },
  },
}));

export const CustSlider = styled(Slider)(({ theme }) => ({
    // color: theme.palette.mode === 'dark' ? '#3880ff' : '#3880ff',
    height: 2,
    padding: '15px 0',
    '& .MuiSlider-thumb': {
      height: 20,
      width: 20,
      backgroundColor: '#fff',
      '&:focus, &:hover, &.Mui-active': {
        boxShadow:
          '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
        },
      },
    },
    '& .MuiSlider-valueLabel': {
      fontSize: 12,
      fontWeight: 'normal',
      top: 3,
      backgroundColor: 'unset',
      color: theme.palette.text.primary,
      '&:before': {
        display: 'none',
      },
      '& *': {
        background: 'transparent',
        color: theme.palette.mode === 'dark' ? '#fff' : '#000',
      },
    },
    '& .MuiSlider-track': {
      border: 'none',
    },
    '& .MuiSlider-rail': {
      opacity: 0.5,
      backgroundColor: '#bfbfbf',
    },
    '& .MuiSlider-mark': {
      backgroundColor: '#bfbfbf',
      height: 10,
      width: 1,
      '&.MuiSlider-markActive': {
        opacity: 1,
        backgroundColor: 'currentColor',
      },
    },
  }))

  export const AmericanJapaneseSwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    '& .MuiSwitch-switchBase': {
      margin: 1,
      padding: 0,
      transform: 'translateX(6px)',
      '&.Mui-checked': {
        color: '#fff',
        transform: 'translateX(22px)',
        '& .MuiSwitch-thumb:before': {
        backgroundImage: `url(${jpflag})`,
        },
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: '#177ddc'
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: '#1976d2',
      width: 32,
      height: 32,
     
      '&:before': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(${usflag})`,
      },
    },
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: 'rgba(255,255,255,.35)',
      //backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      borderRadius: 20 / 2,
    },
  }))

 export const FooterContainer = styled('div')({
    position: 'relative',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // add more styles as needed
  });
  export const StyledLink = styled('button')(({ theme }) => ({
    ...theme.typography.caption,
    opacity:0.65,
    color: 'inherit', 
    cursor: 'pointer', 
    border: 'none', 
    background: 'none', 

    '&:hover': {
      opacity: 1,
    },
}));


  export const Copyright = styled('div')(({ theme }) => ({
    ...theme.typography.caption,
    opacity:0.5,
    fontSize: '0.65rem',
    padding: theme.spacing(.2),
  }));

  export const DotStepper = styled(MobileStepper)(({ theme }) => ({
    ...theme.typography.caption,
    backgroundColor: 'transparent',
  }));

  export const FabMenuButton = styled(Fab)(({ theme }) => ({
    ...theme.typography.caption,
    backgroundColor: grey[800], 
    "&:hover": { backgroundColor: grey[700] }
  }));

  export const FabMenuButtonSmall = styled(Fab)(({ theme }) => ({
    ...theme.typography.caption,
    backgroundColor: isMobile() ? `rgba(169,169,169,0.85)` : `rgba(169,169,169,0.35)`,
    width: '50%',
    height: '50%', 
    "&:hover": { backgroundColor: `rgba(119,119,119,1)` },
    size: "small"
  }));

  // export const CustLinearProgress = styled(LinearProgress)(({ theme }) => ({
  //   height: 5,
  //   colorPrimary: {
  //     backgroundColor: "black"
  //   },
  //   barColorPrimary: {
  //     backgroundColor: "red"
  //   }
  // })) 
  